import { api } from './cliente.js';

export type EstadoAtividade = 'Pendente' | 'EmAndamento' | 'Bloqueada' | 'Concluida' | 'Cancelada';

export interface Atividade {
  id: string;
  faseId: string;
  nome: string;
  descricao: string | null;
  responsavel: string | null;
  esforcoEstimadoH: number | null;
  inicioPrevisto: string | null;
  fimPrevisto: string | null;
  estado: EstadoAtividade;
  bloqueioTipo: 'raid' | 'dependencia' | null;
  bloqueioRef: string | null;
  origem: 'blueprint' | 'manual';
  criadoPor: string;
  criadoEm: string;
}

export interface ColunaKanban {
  estado: EstadoAtividade;
  atividades: Atividade[];
}

export interface CelulaPainelSemanal {
  atividadeId: string;
  data: string;
  horas: number;
}

export const atividadesApi = {
  kanbanPorFase: (faseId: string) => api.get<ColunaKanban[]>(`/atividades/fase/${faseId}/kanban`),
  apontar: (atividadeId: string, recursoId: string, horas: number, data: string) =>
    api.post(`/atividades/${atividadeId}/apontamentos`, { recursoId, data, horas }),
  painelSemanal: (recursoId: string, inicio: string, fim: string) =>
    api.get<CelulaPainelSemanal[]>(`/recursos/${recursoId}/painel-semanal?inicio=${inicio}&fim=${fim}`),
  definirPredecessora: (id: string, predecessoraId: string | null) => api.post(`/atividades/${id}/predecessora`, { predecessoraId }),
  editarDatas: (id: string, inicioPrevisto: string, fimPrevisto: string) =>
    api.post(`/atividades/${id}/datas`, { inicioPrevisto, fimPrevisto }),
};
